<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
  </div>
  <mat-card style="width: 100%;">
    <div>
      <div>
        <mat-card-title>{{langObj ? langObj?.NEWCILDashBoards : ('NEWCILDashBoards' | translate)}}</mat-card-title>
      </div>
      <div>

        <form [formGroup]="CLLDashboardForm">
          <div class="content-top-row">
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>{{langObj ? langObj?.Line : ('Line' | translate)}} </mat-label>
              <mat-select ngxMatSelect #lineOj="ngxMatSelect" [displayMember]="'PL_Desc'" [valueMember]="'PL_Id'"
                [source]="filteredLines" [useInfiniteScroll]="true" formControlName="line" [multiple]="true">
                <mat-option [value]="'0'" (click)="selectAllLines()">
                  {{langObj ? langObj?.All : ('All' | translate)}}
                </mat-option>
                <ng-container *ngIf="filteredLines && filteredLines.length > 0">
                  <mat-option [value]="line.PL_Id ? line.PL_Id : null" *ngFor="let line of lineOj.filteredSource">
                    {{ line.PL_Desc }}
                  </mat-option>
                </ng-container>
                <!-- <mat-option [value]="line.PL_Id" *ngFor="let line of lineOj.filteredSource">
                  {{ line.PL_Desc }}
                </mat-option> -->
              </mat-select>
            </mat-form-field>
            <mat-form-field appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-label>{{langObj ? langObj?.Frequency : ('Frequency' | translate)}}</mat-label>
              <mat-select ngxMatSelect #FreqObj="ngxMatSelect" [displayMember]="'name'" [valueMember]="'id'"
                [source]="frequencyDropList" [useInfiniteScroll]="true" formControlName="frequency" [multiple]="true"
                placeholder="{{langObj ? langObj?.SelectFrequency : ('SelectFrequency' | translate)}}">
                <mat-option [value]="'0'" (click)="selectAllFrequency()">
                  {{langObj ? langObj?.All : ('All' | translate)}}
                </mat-option>
                <mat-option [value]="frequency.id" *ngFor="let frequency of FreqObj.filteredSource">
                  {{frequency.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="inputField" style="width: 25%; margin-left:25px; ">
              <nz-range-picker style="margin-left: 0px !important;" class="calender-input" [nzInputReadOnly]="'true'"
                [nzDisabledDate]="disabledDate" [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd-MM-yyyy HH:mm"
                formControlName="datePicker">
              </nz-range-picker>
              <span class="floating-text">{{langObj ? langObj?.DateRange : ('DateRange' | translate)}}</span>
            </div>
            <button mat-mini-fab mat-button color="primary" type="button" pTooltip="Search" tooltipPosition="top" style="margin-left: 10px;margin-top: auto;
                    margin-bottom: auto;" (click)="getData();">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>
  </mat-card>
  <div class="menu-card-group">
    <div class="menu-card-item mat-card-height">
      <p class="title-text">{{langObj ? langObj?.TotalTasksScheduled : ('TotalTasksScheduled' | translate)}}</p>
      <p class="data-text">
        {{TotalDefects}}
        <span class="data-text small-data-text"></span>
      </p>
      <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
        <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
      </div>
    </div>
    <div class="menu-card-item mat-card-height">
      <p class="title-text">{{langObj ? langObj?.TasksExecuted : ('TaskExecuted' | translate)}}</p>
      <p class="data-text">
        {{TotalDefecteSolved}}
        <span class="data-text small-data-text"></span>
      </p>
      <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
        <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
      </div>
    </div>
    <div class="menu-card-item mat-card-height">
      <p class="title-text">{{langObj ? langObj?.TasksNotExecuted : ('TasksNotExecuted' | translate)}}</p>
      <p class="data-text">
        {{TotalDefectsPerc}}
        <span class="data-text small-data-text"></span>
      </p>
      <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
        <img class="img" [src]="menuRedIconUrl" alt="{{ menuRedIconUrl }}" />
      </div>
    </div>
    <div class="menu-card-item mat-card-height">
      <p class="title-text">{{langObj ? langObj?.CILAdherence : ('CILAdherence' | translate)}}</p>
      <p class="data-text">
        {{CILAdherence}}
        <span class="data-text small-data-text"></span>
      </p>
      <div class="menu-bottom-icon" [ngClass]="{'rtlImage': languageDir == 'rtl'}">
        <img class="img" [src]="menuRedIconUrl" alt="{{ menuGreenIconUrl }}" />
      </div>
    </div>
  </div>
  <!-- chart -->
  <div class="chart-group">
    <div class="chart-items-l">
      <div [chart]="chartCILType"></div>
    </div>
  </div>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="acc1" class="disable_ripple_acc1">
        <mat-panel-title>
          {{langObj ? langObj?.Report : ('Report' | translate)}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <section>
        <div class="import_export">
          <button type="button" (click)="excelExport()" class="export" *ngIf="(isAccess | permissionChecker)">{{langObj ?
            langObj?.DownloadExcelexportfile :
            ('DownloadExcelexportfile' | translate)}}</button>
        </div>
      </section>
      <mat-card-content>
        <ag-grid-angular style="width: 100%;height:560px;" #eGrid class="ag-theme-alpine" [rowData]="rowData"
          [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (cellClicked)="cellClicked($event)"
          [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="10"
          [loadingOverlayComponent]="loadingOverlayComponent">
        </ag-grid-angular>
      </mat-card-content>
    </mat-expansion-panel>
  </mat-accordion>

</div>
<ng-template #imageZoomModel>
  <img [src]="currentImagePath" style="height: 98%; width: 100%; overflow: hidden;">
</ng-template>
<ng-template #displayResponsibleModal>
  <div class="table-div">
    <table>
      <thead>
        <tr>
          <th>{{langObj ? langObj?.ResponsibleUsers : ('ResponsibleUsers' | translate)}}</th>
          <!-- <th>Positions / Role</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of AssignedUsers; let i = index;">
          <td>
            {{user.FullName}}
          </td>
          <!-- <td>QC Leader</td> -->
        </tr>
      </tbody>
    </table>
  </div>

</ng-template>